<script setup lang="ts">
import { findColorValue } from '@/utils/style'
import { UserRole } from '@/types/common/users'
import Title from '@/components/atoms/Title/index.vue'
import Badge from '@/components/atoms/Badge/index.vue'
import Btn from '@/components/atoms/Btn/index.vue'

const props = defineProps<{
  title: string
  categoryName?: string
  pref?: string
  userRole?: UserRole
  isBookmark?: boolean
  hundleBookmark?: (isBookmark: boolean) => Promise<void> | void
}>()

const hundleBookmark = (isBookmark: boolean) => {
  if (props.hundleBookmark === undefined) return
  props.hundleBookmark(isBookmark)
}
</script>

<template>
  <div class="title">
    <Title tag="h1" color="dark-brown" type="bar" class="title-wrapper">
      <div class="title-contents">
        <span>{{ props.title }}</span>
        <Badge
          v-if="props.categoryName !== undefined"
          color="dark-brown"
          :label="props.categoryName"
          font-size="16px"
          font-color="white"
          class="title-badge"
        />
        <Badge
          v-if="props.pref !== undefined"
          color="dark-brown"
          :label="props.pref"
          font-size="16px"
          font-color="white"
          class="title-badge"
        />
        <template v-if="props.userRole !== 'photographer' && props.hundleBookmark !== undefined">
          <Btn
            v-if="props.isBookmark"
            tag="button"
            :color="'red'"
            :is-round="true"
            :font-size="'12px'"
            :text-color="'white'"
            class="bookmark registered-break-sp"
            aria-label="ブックマークを解除"
            @click="hundleBookmark(!props.isBookmark)"
          >
            <div class="bookmark-icon registered">
              <svg viewBox="0, 0, 24, 24">
                <use :xlink:href="'../assets/images/iconmonstr-bookmark-43.svg#symbol'" style="max-width: 10px"></use>
              </svg>
            </div>
            <span class="bookmark-text registered">ブックマークを解除</span>
          </Btn>
          <Btn
            v-else
            tag="button"
            :color="'very-light-gray'"
            :is-round="true"
            :font-size="'12px'"
            :text-color="'black'"
            class="bookmark"
            aria-label="ブックマークに登録"
            @click="hundleBookmark(!props.isBookmark)"
          >
            <div class="bookmark-icon">
              <svg viewBox="0, 0, 24, 24">
                <use :xlink:href="'../assets/images/iconmonstr-bookmark-43.svg#symbol'" style="max-width: 10px"></use>
              </svg>
            </div>
            <span class="bookmark-text">ブックマークに登録</span>
          </Btn>
        </template>
      </div>
    </Title>
  </div>
</template>

<style lang="scss" scoped>
.title {
  .title-wrapper {
    color: v-bind('findColorValue("white")');
    font-size: 22px;
    font-weight: normal;
    padding: 20px 30px;
    margin-bottom: 0px;
    @media (max-width: 767px) {
      font-size: 18px;
      padding: 10px;
    }
  }
  .title-contents {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }

  .title-badge {
    border: 1px solid #84705b;
    border-radius: 100px;
  }
  .bookmark {
    position: relative;
    width: 160px;
    height: 35px;
    line-height: 35px;
    margin-left: auto;
    @media (max-width: 767px) {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
    &.registered-break-sp {
      @media (max-width: 767px) {
        background-color: v-bind('findColorValue("very-light-gray")') !important;
      }
    }
  }
  .bookmark-icon {
    position: absolute;
    top: 9px;
    left: 11px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    fill: v-bind('findColorValue("light-gray")');
    @media (max-width: 767px) {
      top: 22%;
      left: 22%;
    }

    &.registered {
      fill: v-bind('findColorValue("white")');
      @media (max-width: 767px) {
        fill: v-bind('findColorValue("red")');
      }
    }
  }
  .bookmark-text {
    display: block;
    position: relative;
    text-align: left;
    left: 35px;
    @media (max-width: 767px) {
      display: none;
    }
  }
}
</style>
